module.exports = __webpack_public_path__ + "img/logo.5e2e2fce.png";